import { object, string } from "yup";

export const campoValidationSchema = object({
  campo: string().required(),
  cosecha: string().oneOf(["1", "0"]).required(),
  acronimo: string().required(),
});
